<div class="navigation-header">
    <div class="left-side">
        <a class="navbar-image" id="nav-hm-logo" routerLink="/">
            <img src="../assets/HouseMark-logo.png" />
        </a>
        <ul class="navbar-list">
            <li class="dropdown-full-width-content" [class.active]="isPageOpen('dashboardSelection')"
                (click)="toggleTab($event, 'dashboardSelection')">
                <a class="nav-link dropdown-toggle" role="button">Dashboard</a>
                <dashboard-selection></dashboard-selection>
            </li>
            <li class="dropdown-full-width-content" [class.active]="isPageOpen('reportsSelectionComponent')"
                (click)="toggleTab($event, 'reportsSelectionComponent')">
                <a class="nav-link dropdown-toggle" role="button">Reports</a>
                <reports-selection></reports-selection>
            </li>
            <li>
                <a routerLink="/analyse" class="nav-link">
                    Analyse
                </a>
            </li>
            <li>
                <a routerLink="/data-sets" class="nav-link">
                    Datasets
                </a>
            </li>
        </ul>
    </div>

    <div class="right-side">
        <ul class="navbar-list">
            <li class="dropdown-full-width-content" [class.active]="isPageOpen('organisationSelection')"
                id="organisation-selection-item" (click)="toggleTab($event, 'organisationSelection')">
                <div class="organisation-name">
                    <a class="nav-link dropdown-toggle" role="button">{{currentOrganisationName}}</a>

                    <div class="organisation-count" *ngIf="organisationService.currentLandlords && organisationService.currentLandlords.length > 1">
                        {{organisationService.currentLandlords.length}}
                    </div>
                </div>
                <organisation-selection></organisation-selection>
            </li>

            <li class="dropdown-full-width-content my-account-menu-item" id="my-account-item"
                [class.active]="isPageOpen('myAccount')" (click)="toggleTab($event, 'myAccount')">
                <i class="hm-icon-myaccount dropdown-toggle"></i>
                <div class="navigation-menu">
                    <my-account></my-account>
                </div>
            </li>
        </ul>
    </div>
</div>

<div id="app-content">
    <sidebar (triggerSliderInit)="ensureSlidersAreSetupInPeerSelection()"></sidebar>
    <div class="router-outlet">
        <sidebar-date-range id="sidebar-date-range"></sidebar-date-range>
        <sidebar-peer-selection id="sidebar-peer-selection"></sidebar-peer-selection>
        <sidebar-help id="sidebar-help"></sidebar-help>
        <router-outlet></router-outlet>
    </div>
</div>

<spinner></spinner>